import React from 'react';
import styled from 'styled-components';
import {
  ClimateCharts,
  useChartsData,
} from '@hotelplan/components.common.climate';
import { useObjectId } from '@hotelplan/libs.context.object-id';
import { sx2CssThemeFn } from '@hotelplan/libs.sx';
import SunHoursPerYear from 'components/core/climate/SunHoursPerYear';
import {
  CHART_PARAMS,
  CHART_PARAMS_BY_TYPE,
} from 'components/domain/climate/ClimateCharts.params';
import { CHART_COLORS } from 'components/domain/climate/ClimateCharts.styles';
import PdpPageContainer from 'components/domain/pdp/PdpPageContainer';
import { useGetPdpClimateQuery } from 'graphql/pdp/GetPdpClimate.generated';
import PdpClimateSkeleton from './PdpClimate.skeleton';

const ClimatePageTitle = styled.h2(
  sx2CssThemeFn({
    color: 'secondary',

    span: {
      color: 'textGray',
    },
  })
);

const PdpClimate: React.FC = () => {
  const { id } = useObjectId();

  const { data, loading } = useGetPdpClimateQuery({ variables: { id } });
  const preparedCharts = useChartsData(
    data?.pdp.content.destinationInfo.climate.charts,
    CHART_PARAMS,
    CHART_PARAMS_BY_TYPE,
    CHART_COLORS
  );

  if (loading) {
    return (
      <PdpPageContainer>
        <PdpClimateSkeleton />
      </PdpPageContainer>
    );
  }

  return (
    <PdpPageContainer>
      <ClimatePageTitle>
        {data?.pdp.content.destinationInfo.destinationName}
        {', '}
        <span>{data?.pdp.content.destinationInfo.resortName}</span>
      </ClimatePageTitle>
      <SunHoursPerYear
        hours={data?.pdp.content.destinationInfo.climate.sunHoursPerYear}
      />
      <ClimateCharts charts={preparedCharts} />
    </PdpPageContainer>
  );
};

export default PdpClimate;
